/**
 * 申請系の抽象モデル
 */
export class AbstractRequestModel {
  constructor({
    id,
    requestStatus,
    reason,
    requestType,
    requestTime,
    requestAccountName,
    requestAccountBelongsTo,
  } = {}) {
    this.id = Number(id) || undefined
    this.requestStatus = requestStatus
    this.reason = reason
    this.requestType = requestType
    this.requestTime = requestTime
    this.requestAccountName = requestAccountName
    this.requestAccountBelongsTo = requestAccountBelongsTo
  }

  get isNew() {
    return !this.id
  }

  get isRejectable() {
    return !['approved', 'rejected'].includes(this.requestStatus)
  }

  get isApprovable() {
    return !['approved', 'rejected'].includes(this.requestStatus)
  }

  get isRejected() {
    return this.requestStatus === 'rejected'
  }

  get isApproved() {
    return this.requestStatus === 'approved'
  }

  get isWaiting() {
    return this.requestStatus === 'waiting'
  }

  get isCancel() {
    return this.requestStatus === 'cancel'
  }
}
